import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription, of, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UiNotificationService {

  constructor(private readonly toastr: ToastrService) { }

  successWithHtml(message: string, title: string = 'Success'): void {
    this.toastr.success(message,
      title,
      {
        enableHtml: true
      });
  }

  success(message: string, title: string = 'Success', timespan: number = 3000): void {
    this.toastr.success(message,
      title,
      {
        timeOut: timespan
      });
  }

  successAsync(message: Observable<string | object>, title: Observable<string | object>, timespan: number = 3000): Subscription {
    return message.subscribe(msg => {
      title.subscribe(tl => {
        this.toastr.success(msg.toString(),
          tl.toString(),
          {
            timeOut: timespan
          });
      });
    });
  }

  error(message: string, title: string = 'Error', timespan: number = 3000): void {
    this.toastr.error(message,
      title,
      {
        timeOut: timespan
      });
  }


  errorAsync(message: Observable<string | object>, title: Observable<string | object>, timespan: number = 3000): Subscription {
    return message.subscribe(msg => {
      title.subscribe(tl => {
        this.toastr.error(msg.toString(),
          tl.toString(),
          {
            timeOut: timespan
          });
      });
    });
  }
}
